var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgInfo(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), React.createElement("g", {
    fill: "none"
  }, React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#00965E",
    stroke: "#00965E",
    strokeWidth: 0.5,
    rx: 12
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M11.968 7.872a.932.932 0 00.944-.928.936.936 0 00-.944-.944.932.932 0 00-.928.944c0 .512.416.928.928.928zm.016 9.504c.704 0 1.808.048 1.808.048v-.432l-.512-.064c-.496-.064-.624-.192-.624-.944v-6s-1.184.592-2.656.736l.08.352c.928 0 1.2.272 1.2.96v3.824c0 .608-.368 1.008-.848 1.072l-.432.064v.432s1.248-.048 1.984-.048z"
  })));
}

export default SvgInfo;